import { FeatureNotificationTypes } from '@frontend/api-feature-notification';
import { i18next } from '@frontend/i18n';
import { default as OnlineBillPaySvg } from '../assets/online-bill-pay.svg';
import { default as PaymentsSvg } from '../assets/payments.svg';
import { default as TextToPaySvg } from '../assets/text-to-pay.svg';
import { CommonActionTrackingIds } from './tracking-ids';
import { FeatureContentType, PaymentActionEnum, PaymentActionType } from './types';

export const PaymentsFeatureContentList: FeatureContentType[] = [
  {
    title: i18next.t('63% of patients are more likely to pay quickly using Text-to-Pay.', {
      ns: 'highValueAdoption>>payments',
    }),
    image: OnlineBillPaySvg,
  },
  {
    title: i18next.t('Save over 2 hours per day using Weave Text-to-Pay.', { ns: 'highValueAdoption>>payments' }),
    image: PaymentsSvg,
  },
  {
    title: i18next.t('83% of offices that use Weave Payments collect faster.', { ns: 'highValueAdoption>>payments' }),
    image: TextToPaySvg,
  },
];

export const PaymentActionsList: PaymentActionType[] = [
  {
    type: PaymentActionEnum.CREATE_INVOICE,
    title: i18next.t('Create a payment request', { ns: 'highValueAdoption>>payments' }),
    iconName: 'in-progress',
    trackingId: 'payment-action-create-invoice',
  },
  {
    type: PaymentActionEnum.ONLINE_BILL_PAY,
    title: i18next.t('Get free Online Bill Pay link', { ns: 'highValueAdoption>>payments' }),
    iconName: 'in-progress',
    trackingId: 'payment-action-online-bill-pay',
  },
  {
    type: PaymentActionEnum.SHARE_INVOICE,
    title: i18next.t('Send Text-to-Pay link to customers', { ns: 'highValueAdoption>>payments' }),
    iconName: 'in-progress',
    trackingId: 'payment-action-share-invoice',
  },
];

export const PAYMENTS_HVA_FF = 'high-value-adoption:payments';
export const PAYMENTS_APPOINMENT_PROMO_FF = 'high-value-adoption:payments:appointments';

export const PAYMENT_ACCOUNT_HELP_LINK = 'https://www.weavehelp.com/weavehelp/categories/Payments';
export const ONLINE_BILL_PAY_ROUTE = '/payments/online-bill-pay';
export const SHARE_INVOICE_ROUTE = '/payments/invoices';

export const FeatureNotificationActionDataMap: Partial<
  Record<FeatureNotificationTypes.FeatureNotificationAction, { label: string; trackingId: string }>
> = {
  [FeatureNotificationTypes.FeatureNotificationAction.ACTION_REMIND_AFTER_3_DAYS]: {
    label: i18next.t('Snooze for 3 days', {
      ns: 'highValueAdoption>>payments',
    }),
    trackingId: CommonActionTrackingIds.REMIND_IN_3_DAYS,
  },
  [FeatureNotificationTypes.FeatureNotificationAction.ACTION_NEVER_SHOW_AGAIN]: {
    label: i18next.t('Never show again', {
      ns: 'highValueAdoption>>payments',
    }),
    trackingId: CommonActionTrackingIds.NEVER_SHOW_AGAIN,
  },
  [FeatureNotificationTypes.FeatureNotificationAction.ACTION_COLLAPSE]: {
    label: i18next.t('Collapse', {
      ns: 'highValueAdoption>>payments',
    }),
    trackingId: CommonActionTrackingIds.COLLAPSE_CARD,
  },
  [FeatureNotificationTypes.FeatureNotificationAction.ACTION_EXPAND]: {
    label: i18next.t('Learn More', {
      ns: 'highValueAdoption>>payments',
    }),
    trackingId: CommonActionTrackingIds.EXPAND_CARD,
  },
};
